<template>
        <b-container fluid>
                <b-alert v-if="reverifyMessage" show variant="info" class="mt-2">
                    {{ reverifyMessage }}
                </b-alert>
                <div class="d-flex justify-content-end mb-2" v-if="canReverify">
                    <b-button variant="warning" size="sm" :disabled="isReverifying || !currentLoi.LOINumber" @click="reverifyLoi">
                        {{ isReverifying ? "Re-verifying..." : "Re-verify LOI" }}
                    </b-button>
                </div>
                <LoanLOIPrint :key="viewerKey" :ApplicationID="ApplicationID" :Loantype="1" :UserID="effectiveUserId" @loi-loaded="onLoiLoaded"></LoanLOIPrint>
        </b-container>

</template>

<script>
import apis from "@/apis";
import LoanLOIPrint from "@/components/RegistrationLoan/LoanLOIPrint";
export default {
    data(){
        return{
            LoanType:1,
                        UserID:"00000000-0000-0000-0000-000000000000",
                        viewerKey: 0,
                        currentLoi: {},
                        isReverifying: false,
                        reverifyMessage: "",
        }
    },
    components: { LoanLOIPrint },
    props:["ApplicationID", "LOINumber"],
    mounted(){
                this.UserID = (this.$route && this.$route.query && this.$route.query.UserID) || this.UserID;
    }
        ,
        computed: {
            effectiveUserId() {
                return this.currentLoi.UserID || this.currentLoi.LoginID || this.UserID || "00000000-0000-0000-0000-000000000000";
            },
            canReverify() {
                return !!this.ApplicationID;
            }
        },
        methods: {
            onLoiLoaded(loi) {
                this.currentLoi = loi || {};
                if (!this.UserID) {
                    this.UserID = loi && (loi.UserID || loi.LoginID) ? (loi.UserID || loi.LoginID) : this.UserID;
                }
            },
            reverifyLoi() {
                const applicantName = [
                    this.currentLoi.ApplicantName,
                    this.currentLoi.FullName,
                ].filter((x) => x && String(x).trim() !== "").join(" ").trim();

                const userId = this.effectiveUserId;
                if (!userId || userId === "00000000-0000-0000-0000-000000000000") {
                    this.reverifyMessage = "Unable to re-verify because beneficiary user details are missing.";
                    return;
                }

                const promptText = window.prompt("Enter remarks for re-verification", "District re-verified after correction");
                if (promptText === null) return;

                this.isReverifying = true;
                apis.RegenerateLOIForBeneficiary({
                    UserID: userId,
                    OldBeneficiaryName: applicantName || null,
                    NewBeneficiaryName: applicantName || null,
                    Reason: "NAME_CHANGE",
                    Remarks: promptText || "District re-verified after correction",
                    UpdatedBy: (this.$store.getters.loggedUser && this.$store.getters.loggedUser.UserId) || null,
                })
                    .then((response) => {
                        if (response && response.status === 200) {
                            this.reverifyMessage = "LOI re-verified successfully. Reloaded latest LOI data.";
                            this.viewerKey += 1;
                            this.currentLoi = {};
                        } else {
                            this.reverifyMessage = "Re-verify request could not be completed.";
                        }
                    })
                    .catch(() => {
                        this.reverifyMessage = "Unable to re-verify LOI.";
                    })
                    .finally(() => {
                        this.isReverifying = false;
                    });
            }
        }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/VerifyLoi.vue